import script from "./CustomSelect.vue?vue&type=script&lang=ts&setup=true"
export * from "./CustomSelect.vue?vue&type=script&lang=ts&setup=true"

import "./CustomSelect.vue?vue&type=style&index=0&id=15e29aa9&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15e29aa9"]])

export default __exports__